
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Registration_Denied = class Notification_Registration_Denied {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _denied_modal_init = false;
    static _denied_modal_action = null;

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let meta;
        let bid_id = null;

        try {
            meta = JSON.parse(this.notification.meta)
            if (meta.bid_id) {
                bid_id = meta.bid_id;
            }

        } catch (e) {
        }

        // Called when we receive a message from the server that the user has been denied on an item in this auction.
        // This is a notification - when the function returns, we will assume the notification has been satasfied.
        // So don't return the notification until we are done with the prompt.

        // See await _.Modal.pick().  Used for editing a pending bid.  may work better.

        // Button handlers.
        if (!_.Notification_Registration_Denied._denied_modal_init) {
            _.Notification_Registration_Denied._denied_modal_init = true;
            _.on_ui_update_once("#ac-modal-registration-denied-btn-bid-chat", function () {
                $(this).click(function () {
                    _.Notification_Registration_Denied._denied_modal_action = 'chat';
                    _.Modal.close_unhidable({ hide_overlay: false });
                })
            });
            _.on_ui_update_once("#ac-modal-registration-denied-btn-close", function () {
                $(this).click(function () {
                    _.Modal.close_unhidable();
                })
            });
        }

        // The modal itself.
        // Call resolve when we are done here.
        await new Promise(function (resolve, reject) {
            (async function () {
                // do {
                _.Notification_Registration_Denied._denied_modal_action = null;

                if (meta.reason && meta.reason.trim() != 'None Given') {
                    $(".ac-modal-registration-denied-explanation-1").show();
                    $(".ac-modal-registration-denied-explanation-2").show().html(_.escape_multiline_string(meta.reason));
                } else {
                    $(".ac-modal-registration-denied-explanation-1").hide();
                    $(".ac-modal-registration-denied-explanation-2").hide();
                }

                let deferred = $.Deferred();

                $("#ac-modal-registration-denied").data('deferred', deferred);

                $("#ac-modal-registration-denied").modal_show();

                // Wait for the modal to close.
                await deferred.promise();

                // If they clicked a relevant button, handle it
                if (_.Notification_Registration_Denied._denied_modal_action == 'chat') {
                    await _.AuctionUI_Chat.chat_show();
                }

                resolve();
            })();
        });

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
    }
}